import { render, staticRenderFns } from "./QuestionCrosswiseBlank.vue?vue&type=template&id=6ad6d684&scoped=true&"
import script from "./QuestionCrosswiseBlank.vue?vue&type=script&lang=js&"
export * from "./QuestionCrosswiseBlank.vue?vue&type=script&lang=js&"
import style0 from "./QuestionCrosswiseBlank.vue?vue&type=style&index=0&id=6ad6d684&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad6d684",
  null
  
)

export default component.exports